<template>
  <v-btn 
    :loading="loading"
    :disabled="loading" 
    color="green"
    block 
    large 
    dark
    @click.native="create" 
  >
    <v-icon dark left>playlist_add</v-icon>สร้างแผนการสอน
  </v-btn>
</template>

<script>
export default {
  props: ['section', 'allowedRoles'],
  data () {
    return {
      loading: null
    }
  },
  methods: {
    create () {
      this.loading = true
      this.$store.dispatch("coursePlan/createCoursePlan", this.section)
        .then((response) => {
          // console.log("coursePlan/createCoursePlan response", response)
          this.$emit('reload')
        }).catch((error)=>{
          console.log('createCoursePlan', error)
          this.loading = false
        })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/management/course/coursePlan/filters/createCoursePlan.vue